import { render, staticRenderFns } from "./ShipmentHandedOverToCurier.vue?vue&type=template&id=7fea0576&"
import script from "./ShipmentHandedOverToCurier.vue?vue&type=script&lang=js&"
export * from "./ShipmentHandedOverToCurier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports